'use strict';
module.exports = require('../../full/instance/reverse');



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/instance/reverse.js
// module id = 599
// module chunks = 13